import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { DecimalPipe } from '@angular/common';

@Directive({
	selector: '[amountValidation]'
})
export class AmountValidationDirective {
	private _maxValue: number;

	@Input('amountValidation')
	set maxValue(value: number) {
		this._maxValue = value;
		this.showValidation(value);
	}

	get maxValue(): number {
		return this._maxValue;
	}

	constructor(
		private element: ElementRef,
		private stringModifier: StringModifierServiceProvider,
		private decimalPipe: DecimalPipe
	) {}

	@HostListener('input', ['$event'])
	onInputChange() {
		const changedValue = this.stringModifier.convertAmountIntoNumber(
			this.element.nativeElement.value
		);

		this.showValidation(changedValue);
	}

	showValidation(inputValue): void {
		const nativeElement = this.element.nativeElement;
		const maxValueConvert = this.decimalPipe.transform(this.maxValue, '1.0-2');

		if (inputValue > this.maxValue || inputValue === 0) {
			nativeElement.setCustomValidity(
				`You must record an amount that is equal to or less than ${maxValueConvert} `
			);
		} else {
			nativeElement.setCustomValidity('');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/directives/AmountValidation/amountValidation.directive.ts